(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer_quotes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var root = document.getElementById('quotes-root');
  if (!root) return;
  var STATUS_LABELS = {
    processing: root.getAttribute('data-status-processing') || 'En cours',
    available: root.getAttribute('data-status-available') || 'Disponible',
    expiredSoon: root.getAttribute('data-status-expired-soon') || 'Expire bientôt',
    expired: root.getAttribute('data-status-expired') || 'Expiré',
    won: root.getAttribute('data-status-won') || 'Accepté',
    lost: root.getAttribute('data-status-lost') || 'Refusé',
    canceled: root.getAttribute('data-status-canceled') || 'Annulé'
  };

  function parseDateOnly(iso) {
    if (!iso) return null;
    var dateOnlyMatch = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
      return new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3])
      );
    }

    var d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function startOfToday() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function daysSince(iso) {
    var d = parseDateOnly(iso);
    if (!d) return null;
    var diffMs = Date.now() - d.getTime();
    return Math.floor(diffMs / 86400000);
  }

  function daysUntil(iso) {
    var d = parseDateOnly(iso);
    if (!d) return null;
    var diffMs = d.getTime() - startOfToday().getTime();
    return Math.floor(diffMs / 86400000);
  }

  function computeStatus(q) {
    var status = (q.status || '').toString();

    // Priorités "dures"
    if (status === 'canceled') return { key: 'canceled', label: STATUS_LABELS.canceled };
    if (status === 'won')      return { key: 'won',      label: STATUS_LABELS.won };
    if (status === 'lost')     return { key: 'lost',     label: STATUS_LABELS.lost };


    if (q.expired === true) return { key: 'expired', label: STATUS_LABELS.expired };
    if (q.expires_soon === true) return { key: 'expired-soon', label: STATUS_LABELS.expiredSoon };

    var validDaysLeft = daysUntil(q.valid_until);
    if (validDaysLeft != null) {
      if (validDaysLeft < 0) return { key: 'expired', label: STATUS_LABELS.expired };
      if (validDaysLeft <= 9) return { key: 'expired-soon', label: STATUS_LABELS.expiredSoon };
    } else {
      var ageDays = daysSince(q.draft_order_created_at);
      if (ageDays > 30) return { key: 'expired', label: STATUS_LABELS.expired };
      if (ageDays > 21 && ageDays <= 30) return { key: 'expired-soon', label: STATUS_LABELS.expiredSoon };
    }

    // Mapping demandé
    if (status === 'pending' || status === 'processing') return { key: 'processing', label: STATUS_LABELS.processing };
    if (status === 'sent') return { key: 'available', label: STATUS_LABELS.available };

    // Fallback (si un nouveau statut apparaît)
    return { key: status || 'processing', label: status || STATUS_LABELS.processing };
  }
  var email    = root.getAttribute('data-email');
  var fetchUrl = root.getAttribute('data-fetch-url');

  var loadingEl = root.querySelector('[data-state="loading"]');
  var errorEl   = root.querySelector('[data-state="error"]');
  var emptyEl   = root.querySelector('[data-state="empty"]');
  var tableWrap = root.querySelector('[data-state="ready"]');
  var bodyEl    = root.querySelector('[data-quotes-body]');

  var labelPay       = root.getAttribute('data-label-pay') || 'Payer';
  var labelDownload  = root.getAttribute('data-label-download') || 'Télécharger';
  var labelViewQuote = root.getAttribute('data-label-view') || 'Voir le devis';
  var labelViewOrder = root.getAttribute('data-label-view-order') || 'Voir la commande';

  function show(state) {
    loadingEl.hidden = state !== 'loading';
    errorEl.hidden   = state !== 'error';
    emptyEl.hidden   = state !== 'empty';
    tableWrap.hidden = state !== 'ready';
  }

  async function loadQuotes() {
    try {
      show('loading');

      var url = new URL(fetchUrl);
      url.searchParams.set('email', email);

      var resp = await fetch(url.toString(), { method: 'GET', credentials: 'same-origin' });
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      var json = await resp.json();

      var quotes = Array.isArray(json) ? json : (json.quotes || []);
      if (!quotes.length) {
        show('empty');
        return;
      }

      // Nettoyage
      bodyEl.innerHTML = '';

      quotes.forEach(function(q) {
        // Champs attendus depuis votre service:
        // id, number, status, currency, created_at, updated_at,
        // total_ht_cents, total_ttc_cents (ou alias cf. pickAmount)
        var number     = q.number || ('#' + (q.id || ''));
        var statusObj = computeStatus(q);
        var currency   = q.currency || 'EUR';
        var createdIso = q.created_at || q.createdAt || '';
        var updatedIso = q.updated_at || q.updatedAt || '';

        var totalHtCents = pickAmount(q, ['total_ht_cents', 'total_excl_tax_cents', 'subtotal_cents']);
        var totalTtcCents = pickAmount(q, ['total_ttc_cents', 'total_incl_tax_cents', 'total_cents']);

        var totalHtText  = totalHtCents != null ? formatMoney(totalHtCents, currency) : '-';
        var totalTtcText = totalTtcCents != null ? formatMoney(totalTtcCents, currency) : '-';

        var row = document.createElement('div');
        row.className = 'account-quotes__row';

        var refCell = document.createElement('div');
        refCell.className = 'account-quotes__cell account-quotes__cell--ref';
        refCell.textContent = number;

        var dateCell = document.createElement('div');
        dateCell.className = 'account-quotes__cell';
        dateCell.textContent = createdIso ? formatDate(createdIso) : '';

        var htCell = document.createElement('div');
        htCell.className = 'account-quotes__cell';
        htCell.textContent = totalHtText;

        var ttcCell = document.createElement('div');
        ttcCell.className = 'account-quotes__cell';
        ttcCell.textContent = totalTtcText;

        var statusCell = document.createElement('div');
        statusCell.className = 'account-quotes__cell';
        statusCell.innerHTML =
          `<span class="account-quotes__badge account-quotes__badge--${statusObj.key}">` +
          escapeHtml(statusObj.label) +
          `</span>`;
        var actionsCell = document.createElement('div');
        actionsCell.className = 'account-quotes__cell account-quotes__cell--actions';

        if (q.draft_order_invoice_url  && !['expired', 'won'].includes(statusObj.key)) {
          var aPay = document.createElement('a');
          aPay.href = q.draft_order_invoice_url;
          aPay.target = '_blank';
          aPay.rel = 'noopener';
          aPay.className = 'button button--primary';
          aPay.innerHTML = '<span>' + escapeHtml(labelPay) + '</span>';
          actionsCell.appendChild(aPay);
        }
        if (statusObj.key === 'won' && q.order_id) {
           var aOrder = document.createElement('a');
           aOrder.href = '/account/orders/' + encodeURIComponent(q.order_id);
           aOrder.className = 'button button--secondary';
           aOrder.innerHTML = '<span>' + escapeHtml(labelViewOrder || 'Voir la commande') + '</span>';
           actionsCell.appendChild(aOrder);
        }

        if (q.pdf_url) {
          var aPdf = document.createElement('a');
          aPdf.href = q.pdf_url;
          aPdf.target = '_blank';
          aPdf.rel = 'noopener';
          aPdf.className = 'button button--secondary';
          aPdf.innerHTML = '<span>' + escapeHtml(labelDownload) + '</span>';

          actionsCell.appendChild(aPdf);
        }

        if (q.detail_url) {
          var aDetail = document.createElement('a');
          aDetail.href = q.detail_url;
          aDetail.className = 'button';
          aDetail.innerHTML = '<span>' + escapeHtml(labelViewQuote) + '</span>';

          actionsCell.appendChild(aDetail);
        }

        row.appendChild(refCell);
        row.appendChild(dateCell);
        row.appendChild(htCell);
        row.appendChild(ttcCell);
        row.appendChild(statusCell);
        row.appendChild(actionsCell);

        bodyEl.appendChild(row);
      });

      show('ready');
    } catch (e) {
      console.error('[quotes] load error', e);
      show('error');
    }
  }

  function pickAmount(obj, keys) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var value = obj[key];
        if (typeof value === 'number') return value;
        if (typeof value === 'string' && value !== '' && !isNaN(Number(value))) {
          return Number(value);
        }
      }
    }
    return null;
  }

  function formatMoney(cents, currency) {
    try {
      var amount = cents / 100;
      // On reste simple, la locale sera celle du navigateur
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' ' + currency;
    } catch (_) {
      return String(cents / 100) + ' ' + currency;
    }
  }

  function formatDate(iso) {
    try {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleDateString(undefined, { year:'numeric', month:'short', day:'2-digit' });
    } catch(_) { return iso; }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  loadQuotes();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
    // Gestion du formulaire de code promo sur la page panier
    const discountForm = document.getElementById('CartDiscountForm');
    if (discountForm) {
      discountForm.addEventListener('submit', function(event) {
        event.preventDefault();
        const input = document.getElementById('CartDiscountCode');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        var redirectPath = window.location.pathname + window.location.search;
        window.location.href = '/discount/' + encodeURIComponent(code)
          + '?redirect=' + encodeURIComponent(redirectPath);
      });
    }

    const discountRemoveButtons = document.querySelectorAll('.cart__discount-tag');
    if (discountRemoveButtons.length) {
      discountRemoveButtons.forEach((button) => {
        button.addEventListener('click', function(event) {
          event.preventDefault();
          const codeToRemove = this.dataset.discountCode;
          const remainingCodes = Array.from(document.querySelectorAll('.cart__discount-tag'))
            .map((btn) => btn.dataset.discountCode)
            .filter((code) => code && code !== codeToRemove);

          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ discount: remainingCodes.join(',') })
          }).then(() => {
            window.location.reload();
          }).catch(() => {
            window.location.reload();
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
